export default {
  common: {
    appName: 'Arena Sport Digital',
    loading: 'Memuat...',
    search: 'Cari',
    searchPlaceholder: 'Cari...',
    filter: 'Saring',
    reset: 'Atur ulang',
    save: 'Simpan',
    cancel: 'Batal',
    delete: 'Hapus',
    edit: 'Ubah',
    add: 'Tambah',
    back: 'Kembali',
    next: 'Berikutnya',
    previous: 'Sebelumnya',
    close: 'Tutup',
    confirm: 'Konfirmasi',
    submit: 'Kirim',
    viewAll: 'Lihat semua',
    viewDetail: 'Lihat detail',
    download: 'Unduh',
    all: 'Semua',
    yes: 'Ya',
    no: 'Tidak',
    optional: 'opsional',
    required: 'wajib',
    noData: 'Belum ada data',
    noDataDesc: 'Data akan muncul di sini setelah tersedia.',
    error: 'Terjadi kesalahan',
    errorDesc: 'Silakan coba beberapa saat lagi.',
    retry: 'Coba lagi',
    showing: 'Menampilkan {from}–{to} dari {total}',
    page: 'Halaman',
    of: 'dari',
  },

  nav: {
    home: 'Beranda',
    about: 'Tentang Kami',
    tournaments: 'Turnamen',
    schedule: 'Jadwal',
    gallery: 'Galeri',
    register: 'Daftar',
    login: 'Masuk',
    logout: 'Keluar',
    dashboard: 'Dasbor',
    privacyPolicy: 'Kebijakan Privasi',
    openMenu: 'Buka menu',
    closeMenu: 'Tutup menu',
    skipToContent: 'Lompat ke konten utama',
    mainNav: 'Navigasi utama',
    scheduleShortcut: 'Jadwal acara',
    seeAllSchedules: 'Lihat semua jadwal',
  },

  theme: {
    label: 'Tampilan',
    light: 'Terang',
    dark: 'Gelap',
    system: 'Ikuti sistem',
    toggle: 'Ganti tema',
  },

  language: {
    label: 'Bahasa',
    indonesian: 'Bahasa Indonesia',
    english: 'English',
    change: 'Ganti bahasa',
  },

  home: {
    featuredTournament: 'Turnamen Pilihan',
    viewEvent: 'Detail',
    feeEyebrow: 'Biaya',
    feeTitle: 'Biaya Pendaftaran',
    feeSubtitle: 'Biaya per atlet untuk tiap kategori pertandingan.',
    feeNote: 'Biaya dihitung otomatis saat Anda menambahkan atlet. Total akan terlihat sebelum pembayaran.',
    contactEyebrow: 'Bantuan',
    contactTitle: 'Hubungi Panitia',
    contactSubtitle: 'Ada yang kurang jelas? Hubungi langsung lewat WhatsApp.',
    badge: 'Platform Turnamen Pencak Silat',
    heroTitleA: 'Satu Arena',
    heroTitleB: 'Untuk Semua',
    heroTitleC: 'Pertandingan',
    heroSubtitle:
      'Daftarkan kontingen, susun bagan, atur jadwal gelanggang, dan pantau hasil secara langsung. Semua dari satu tempat.',
    ctaRegister: 'Daftar Sekarang',
    ctaSchedule: 'Lihat Jadwal',
    eventInfo: 'Info Acara',

    registrationOpen: 'Pendaftaran Dibuka',
    registerContingent: 'Daftarkan Kontingen',
    moreInfo: 'Selengkapnya',

    openEyebrow: 'Sedang Berlangsung',
    openTitle: 'Turnamen Terbuka',
    allTournaments: 'Semua Turnamen',
    statusOpen: 'Dibuka',

    ctaEyebrow: 'Siap Menggelar Kejuaraan?',
    ctaTitle: 'Mulai Hari Ini',
    ctaText: 'Buat akun, daftarkan kontingen, dan biarkan sistem mengurus sisanya.',
    ctaPrimary: 'Daftar Kontingen',
    ctaSecondary: 'Masuk ke Akun',

    loadFailed: 'Gagal memuat data',
    noOpenTournament: 'Belum ada turnamen terbuka',
    noOpenTournamentDesc: 'Turnamen yang membuka pendaftaran akan tampil di sini.',
  },

  status: {
    dibuka: 'Pendaftaran Dibuka',
    dibukaSingkat: 'Dibuka',
    segeraHadir: 'Segera Hadir',
    selesai: 'Selesai',
    sembunyikan: 'Disembunyikan',
    belumDibuka: 'Pendaftaran belum dibuka',
    belumDibukaDesc: 'Pantau terus halaman ini — pendaftaran akan diumumkan.',
    sudahSelesai: 'Kejuaraan telah selesai',
    sudahSelesaiDesc: 'Pendaftaran sudah ditutup. Lihat jadwal dan hasilnya.',
    berlangsung: 'Sedang Berlangsung',
  },

  about: {
    eyebrow: 'Tentang Kami',
    titleA: 'Membangun Panggung Olahraga',
    titleB: 'Digital & Profesional',
    desc: 'Arena Sport Digital (ARSPO) berdiri sejak tahun 2024 sebagai promotor turnamen olahraga terkemuka yang memadukan semangat sportivitas dengan inovasi teknologi informasi terkini.',
    statsYear: 'Tahun Berdiri',
    statsRealtime: 'Digital & Real-time',
    statsFairplay: 'Standar Sportivitas',
    visionTitle: 'Visi Kami',
    missionTitle: 'Misi Kami',
    valuesTitle: 'Nilai & Dedikasi',
    ctaTitle: 'Siap Bertanding di Arena Sport Digital?',
    ctaDesc: 'Lihat kejuaraan yang sedang berlangsung atau hubungi tim kami untuk kemitraan turnamen.',
  },

  tournament: {
    eyebrow: 'Agenda Kejuaraan',
    registrationDeadline: 'Terakhir Daftar',
    deadlinePassed: 'sudah ditutup',
    deadlineToday: 'hari ini terakhir',
    deadlineLeft: 'tersisa {n} hari',
    joinGroup: 'Grup WhatsApp',
    title: 'Turnamen',
    subtitle: 'Daftar kejuaraan yang diselenggarakan',
    detail: 'Detail Turnamen',
    location: 'Lokasi',
    date: 'Tanggal Pelaksanaan',
    technicalMeeting: 'Rapat Teknis',
    status: 'Status',
    description: 'Deskripsi',
    categories: 'Kategori Dipertandingkan',
    ageCategories: 'Kategori Usia',
    activities: 'Rangkaian Acara',
    contactPersons: 'Narahubung',
    registrationFee: 'Biaya Pendaftaran',
    document: 'Proposal Kejuaraan',
    downloadDocument: 'Unduh Proposal',
    statusActive: 'Dibuka',
    statusInactive: 'Ditutup',
    statusDraft: 'Draf',
    statusFinished: 'Selesai',
    empty: 'Belum ada turnamen',
    emptyDesc: 'Turnamen yang dibuka akan tampil di halaman ini.',
    ageRange: '{min}–{max} tahun',
  },

  schedule: {
    title: 'Jadwal Pertandingan',
    subtitle: 'Susunan partai per gelanggang',
    tanding: 'Tanding',
    seni: 'Seni',
    arena: 'Gelanggang',
    matchNumber: 'Partai',
    round: 'Babak',
    time: 'Waktu',
    date: 'Tanggal',
    blueCorner: 'Sudut Biru',
    redCorner: 'Sudut Merah',
    contingent: 'Kontingen',
    class: 'Kelas',
    category: 'Kategori',
    pool: 'Pul',
    winner: 'Pemenang',
    tbd: 'Belum ditentukan',
    winnerFrom: 'Pemenang partai #{number}',
    filterByArena: 'Saring gelanggang',
    filterByDate: 'Saring tanggal',
    filterByRound: 'Saring babak',
    allArenas: 'Semua gelanggang',
    allDates: 'Semua tanggal',
    allRounds: 'Semua babak',
    empty: 'Jadwal belum tersedia',
    emptyDesc: 'Jadwal akan tampil setelah panitia menyusun pertandingan.',
    statusNotStarted: 'Belum mulai',
    statusInProgress: 'Berlangsung',
    statusFinished: 'Selesai',
    exportExcel: 'Unduh Excel',
    filterDate: 'Filter Tanggal',
    filterArena: 'Filter Arena',
    filterPool: 'Filter Pool',
    filterRound: 'Filter Babak',
    filterCategory: 'Filter Kategori',
    filterGender: 'Filter Jenis Kelamin',
    filterClass: 'Filter Kelas',
    allPools: 'Semua Pool',
    allCategories: 'Semua Kategori',
    allGenders: 'Semua Jenis Kelamin',
    allClasses: 'Semua Kelas',
    titleTanding: 'Jadwal Pertandingan Kategori Tanding',
    titleSeni: 'Jadwal Pertandingan Kategori Seni',
    participant1: 'Peserta 1',
    participant2: 'Peserta 2',
  },

  // Halaman daftar jadwal (/schedule)
  scheduleIndex: {
    filterEvent: 'Pilih Acara',
    filterType: 'Jenis Pertandingan',
    eyebrow: 'Jadwal Pertandingan',
    title: 'Pilih Acara',
    subtitle: 'Buka jadwal tanding atau seni dari acara yang Anda ikuti.',
    searchPlaceholder: 'Cari nama acara atau kota…',
    empty: 'Belum ada acara',
    emptyDesc: 'Jadwal akan tampil di sini setelah panitia membuat acara.',
    noMatch: 'Tidak ada yang cocok',
    noMatchDesc: 'Coba kata kunci lain, atau kosongkan pencariannya.',
    clearSearch: 'Kosongkan pencarian',
  },

  auth: {
    loginTitle: 'Masuk ke Akun',
    loginSubtitle: 'Kelola kontingen dan pendaftaran atlet Anda.',
    registerTitle: 'Buat Akun Baru',
    registerSubtitle: 'Daftarkan kontingen Anda ke kejuaraan.',
    email: 'Alamat Email',
    /*
     * Tanda @ WAJIB ditulis sebagai {'@'}.
     *
     * vue-i18n memakai @ untuk merujuk pesan lain (@:kunci.lain). Ditulis
     * polos, penyusun pesan membaca "@email.com" sebagai rujukan yang salah
     * bentuk, melempar SyntaxError "Invalid linked format", dan render
     * komponen GAGAL TOTAL — halaman masuk tampil kosong tanpa satu pun
     * pesan galat yang terlihat pengguna.
     */
    emailPlaceholder: "nama{'@'}email.com",
    password: 'Kata Sandi',
    passwordPlaceholder: 'Masukkan kata sandi',
    passwordConfirm: 'Ulangi Kata Sandi',
    personResponsible: 'Nama Penanggung Jawab',
    personResponsiblePlaceholder: 'Nama lengkap',
    rememberMe: 'Ingat saya',
    forgotPassword: 'Lupa kata sandi?',
    loginButton: 'Masuk',
    registerButton: 'Daftar',
    noAccount: 'Belum punya akun?',
    hasAccount: 'Sudah punya akun?',
    registerHere: 'Daftar di sini',
    loginHere: 'Masuk di sini',
    showPassword: 'Tampilkan kata sandi',
    hidePassword: 'Sembunyikan kata sandi',
    passwordHint: 'Minimal 8 karakter, berisi huruf dan angka.',
    loginSuccess: 'Berhasil masuk. Selamat datang kembali.',
    logoutSuccess: 'Anda telah keluar.',
    invalidCredentials: 'Email atau kata sandi salah.',
    tooManyAttempts: 'Terlalu banyak percobaan. Coba lagi dalam beberapa menit.',
    sessionExpired: 'Sesi Anda telah berakhir. Silakan masuk kembali.',
  },

  registration: {
    eyebrow: 'Pendaftaran Kontingen',
    titleA: 'Daftarkan',
    titleB: 'Kontingen',
    titleC: 'Anda',
    stepAccount: 'Akun',
    stepCategory: 'Kategori',
    stepOtp: 'Verifikasi Email',
    accountTitle: 'Data Penanggung Jawab',
    accountHint: 'Akun ini dipakai untuk mengelola seluruh atlet kontingen Anda.',
    fullName: 'Nama Lengkap Penanggung Jawab',
    fullNamePlaceholder: 'Contoh: Budi Santoso',
    passwordPlaceholder: 'Minimal 8 karakter',
    passwordRepeat: 'Ketik ulang',
    strengthWeak: 'Lemah',
    strengthFair: 'Cukup',
    strengthStrong: 'Kuat',
    categoryTitle: 'Kategori Yang Diikuti',
    categoryHint:
      'Pilih kategori yang akan diikuti kontingen Anda. Bisa diubah kapan saja setelah akun dibuat.',
    categoryEmpty: 'Kategori belum diumumkan',
    categoryEmptyDesc: 'Anda tetap bisa membuat akun dan memilih kategori nanti.',
    perAthlete: '/ atlet',
    selectedCount: 'Kategori dipilih',
    estimatedCost: 'Perkiraan biaya per atlet',
    costNote:
      'Biaya sebenarnya dihitung ulang oleh panitia berdasarkan jumlah atlet yang Anda daftarkan.',
    otpTitle: 'Verifikasi Email Anda',
    otpHint: 'Kami telah mengirimkan 6 digit kode OTP ke surel:',
    otpLabel: 'Masukkan 6 Digit Kode OTP',
    otpPlaceholder: '000000',
    resendOtp: 'Kirim Ulang Kode OTP',
    resendOtpIn: 'Kirim ulang dalam {n} detik',
    sendingOtp: 'Mengirim kode OTP...',
    verifyingOtp: 'Memverifikasi kode OTP...',
    verifyAndFinish: 'Verifikasi & Selesaikan Pendaftaran',
    changeEmail: 'Ubah Data Akun',
    continue: 'Lanjut',
    sendOtpButton: 'Kirim Kode Verifikasi',
    finish: 'Selesaikan Pendaftaran',
    submitting: 'Mendaftarkan...',
    checkFields: 'Periksa kembali isian yang ditandai.',
    failed: 'Pendaftaran gagal. Silakan coba lagi.',
    success: 'Akun berhasil dibuat dan email terverifikasi. Selamat datang!',
    needHelp: 'Butuh bantuan?',
    help1: 'Satu akun bisa dipakai untuk beberapa turnamen sekaligus.',
    help2: 'Atlet ditambahkan setelah akun jadi, lewat menu Atlet.',
    help3: 'Tagihan terbit otomatis begitu atlet didaftarkan.',
  },

  validation: {
    required: '{field} wajib diisi.',
    email: 'Format email tidak valid.',
    minLength: '{field} minimal {min} karakter.',
    passwordMismatch: 'Konfirmasi kata sandi tidak cocok.',
    nameRequired: 'Nama penanggung jawab wajib diisi.',
    emailRequired: 'Email wajib diisi.',
    passwordRequired: 'Kata sandi wajib diisi.',
    passwordMin: 'Kata sandi minimal 8 karakter.',
    passwordFormat: 'Kata sandi harus memuat huruf dan angka.',
    passwordRepeatMismatch: 'Ulangan kata sandi tidak cocok.',
  },

  footer: {
    tagline:
      'Sistem manajemen turnamen pencak silat — dari pendaftaran kontingen sampai pengumuman juara.',
    explore: 'Jelajahi',
    contact: 'Kontak',
    appearance: 'Tampilan',
    followUs: 'Ikuti Kami',
    rights: 'Seluruh hak cipta dilindungi.',
  },
};
